<template>
  <div @click.stop="preventClick">
    <div v-if="activeObject.type === 'shape' || activeObject.ImageType === 'SVGImage'" class="btn-group color-option" role="group" aria-label="Basic radio toggle button group">
      <input type="radio" class="btn-check" name="btnradio" id="btnradio1" autocomplete="off" :checked="!activeObject.isGradient" @change="onModeChange(false)"/>
      <label class="btn" for="btnradio1">Color</label>

      <input type="radio" class="btn-check" name="btnradio" id="btnradio2" autocomplete="off" :checked="activeObject.isGradient" @change="onModeChange(true)"/>
      <label class="btn" for="btnradio2">Gradient</label>
    </div>
    <color-picker
      :color="selectedColorValue"
      :sucker-hide="true"
      :sucker-canvas="suckerCanvas"
      :sucker-area="suckerArea"
      :colors-default="['#000000', '#FFFFFF', '#FF1900', '#F47365', '#FFB243', '#FFE623', '#6EFF2A', '#1BC7B1', '#00BEFF', '#2E81FF', '#5D61FF', '#FF89CF', '#FC3CAD', '#BF3DCE', '#8E00A7','#927549']"
      :colors-history-key="'none'"
      :display-style="displayStyle"
      :active-object="activeObject"
      theme="dark"
      @updateSelectedPointPosition="updateSelectedPointPosition"
      @updateSelectedPointOfGradient="updateSelectedPointOfGradient"
      @changeColor="changeColor"
      @openSucker="openSucker"
      @updateSelectedGradientAngle="updateSelectedGradientAngle"
    />
  </div>
</template>

<script>
import Color from '@/components/BMColorPicker';
import { rgbToCmyk } from '@/components/Helper';
import EventBus from '@/EventBus';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes'; // TDOD: Change to @/

export default {
  name: 'ColorPicker',

  components: { 'color-picker': Color },
  props:      {
    color: String,
    type:  {
      type:    String,
      default: 'text',
    },
    displayStyle: {
      type:    String,
      default: 'inline',
    },
    colorType: {
      type:    String,
      default: 'fill',
    },
    activeObject:{
      type: Object,
      default: {}
    },
    isForShadowColor:{
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      suckerCanvas:       null,
      suckerArea:         [],
      isSucking:          false,
      boundingReact:      null,
      selectedColorValue: this.color,
    };
  },
  computed: {
    getPositionClass() {
      if (this.position === 'float') { return 'position-fixed '; }
      return '';
    },
    colorPickerColor() {
      return this.selectedColorValue;
    },
  },
  methods: {
    updateSelectedGradientAngle(angle) {
      this.$emit('updateSelectedGradientAngle', angle);
    },
    updateSelectedPointPosition(position) {
      this.$emit('updateSelectedPointPosition', position);
    },
    updateSelectedPointOfGradient(index) {
      this.$emit('updateSelectedPointOfGradient', index);
    },
    onModeChange(isGradient) {
      this.$emit('changeMode', isGradient);
    },
    preventClick() {},
    changeColor(color) {
      this.selectedColorValue = color.hex;
      const Rgb               = `rgba(${color.rgba.r}, ${color.rgba.g}, ${color.rgba.b}, ${color.rgba.a})`;
      if (this.isForShadowColor) {
        if (this.activeObject.textShadow.textEffect === 'shadow') {
          EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CHANGE_TEXT_SHADOW_COLOR, Rgb);
        } else if (this.activeObject.outLine.textEffect === 'outline') {
          EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CHANGE_TEXT_OUTLINE_COLOR, Rgb);
        }
        return;
      }
      this.type == 'text' && (EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CHANGE_TEXT_COLOR, Rgb));
      if (this.type == 'shape') {
        if (this.colorType == 'fill') { EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CHANGE_SHAPE_COLOR, Rgb); }
        if (this.colorType == 'outline') { EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CHANGE_SHAPE_STROKE, Rgb); }
      }
      if (this.type == 'SVGImage' && !this.activeObject.isGradient) {
        if (this.colorType === 'fill') { EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CHANGE_SVG_FILL_COLOR, Rgb); }
        if (this.colorType === 'outline') { EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CHANGE_SVG_STROKE_COLOR, Rgb); }
      } else {
        EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CHANGE_SHAPE_COLOR, Rgb);
      }
    },

    openSucker(isOpen) {
      alert(isOpen);
      if (isOpen) {
        this.suckerCanvas  = document.getElementById('main_html');
        this.boundingReact = document.getElementById('main_html').getBoundingClientRect();
        this.suckerArea    = [this.boundingReact.left, this.boundingReact.top, this.boundingReact.right, this.boundingReact.bottom];
      } else {
        this.suckerCanvas && this.suckerCanvas.remove;
      }
    },
  },
};

</script>
<style scoped lang="scss">
  #picker-wrapper {
    width: 200px;
    height: 200px;
    position: relative;
  }
  #slider-wrapper {
    width: 30px;
    height: 200px;
    position: relative;
  }
  #picker-indicator {
    width: 3px;
    height: 3px;
    position: absolute;
    border: 1px solid white;
  }
  #slider-indicator {
    width: 100%;
    height: 10px;
    position: absolute;
    border: 1px solid black;
  }
  .color-option {
    padding: 0px 20px 0px 20px;
    width: 100%;
    margin-bottom: 10px;
  }

</style>
